// Module
var code = "<template>\n  <div class=\"delivery-component\">\n    <p>Delivery tracking for Production Order: ${productionOrderId}</p>\n  </div>\n</template>\n";
// Exports
export default code;